package com.example.mystybag.appCore.model.addMerchantLocation

data class MerchantRegistrationAddDescriptionUIState(
    val isLoading: Boolean = false,
    val selectedBusinessCategory: BusinessCategoryItem? = null,
    val businessCategories: List<BusinessCategoryItem> = emptyList(),
    val showBusinessCategoryPicker: Boolean = false,
    val selectedPreviewImageIndex: Int? = null,
    val requiredCoverPreviewError: Boolean = false,
    val productRows: List<ProductRowUIModel> = listOf(ProductRowUIModel()),
    val requiredBusinessCategoryError: Boolean = false,
    val requiredProductNameRows: Set<Int> = emptySet(),
    val requiredProductGramsRows: Set<Int> = emptySet(),
    val validationRequestId: Int = 0
)

data class ProductRowUIModel(
    val productName: String = "",
    val grams: String = ""
)

